import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/partner-accounts' }, ServiceProxyMap.PPC_BFF);

export async function getPartnerAccountsDomains(partnerAccountIds: string[]) {
  const result = await client.post('/domains', { partnerAccountIds });

  return result.data;
}
